import cn from 'classnames';

export enum AlertType {
  ERROR = 'error',
  SUCCESS = 'success',
}

interface AlertProps {
  title?: string;
  message: string;
  type: AlertType;
  className?: string;
}

export function Alert({ title, message, type, className }: AlertProps) {
  const isError = type === AlertType.ERROR;
  const isSuccess = type === AlertType.SUCCESS;
  return (
    <div
      className={cn(className, 'rounded-md p-4', {
        'bg-red-50': isError,
        'bg-green-50': isSuccess,
      })}
    >
      <div className="flex">
        <div className="flex-shrink-0">
          {isError && <ErrorIcon />}
          {isSuccess && <SuccessIcon />}
        </div>
        <div className="ml-3">
          {title && (
            <h3
              className={cn('text-sm font-medium ', {
                'text-green-800': isSuccess,
                'text-red-800': isError,
              })}
            >
              {title}
            </h3>
          )}
          <div
            className={cn(' text-sm', {
              'mt-2': !!title,
              'text-green-700': isSuccess,
              'text-red-700': isError,
            })}
          >
            <p>{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

const SuccessIcon = () => (
  <svg
    className="w-5 h-5 text-green-400"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
      clipRule="evenodd"
    />
  </svg>
);

const ErrorIcon = () => (
  <svg
    className="w-5 h-5 text-red-400"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
      clipRule="evenodd"
    />
  </svg>
);
